module.exports = __webpack_public_path__ + "img/ico_checklist.dc957a03.svg";